import "./menu.scss";

export default function Menu() {
    return (
        <ul className="menu">
            <li>
                <a href="#intro">Home</a>
            </li>
            <li>
                <a href="#about-me">About me</a>
            </li>
            <li>
                <a href="#portfolio">Portfolio</a>
            </li>
        </ul>
    )
}
